import { Platform } from "react-native";

const RETURN_KEY = "recital-master:return-after-login";

export function rememberPostLoginReturn(): void {
  if (Platform.OS !== "web" || typeof window === "undefined") return;
  const path = `${window.location.pathname}${window.location.search}`;
  if (!path.startsWith("/") || path.startsWith("//")) return;
  window.localStorage.setItem(RETURN_KEY, path);
}

export function consumePostLoginReturn(): string | null {
  if (Platform.OS !== "web" || typeof window === "undefined") return null;
  const path = window.localStorage.getItem(RETURN_KEY);
  window.localStorage.removeItem(RETURN_KEY);
  return path?.startsWith("/") && !path.startsWith("//") ? path : null;
}
